const getInvoicesPath = ({ isNetworkLead, showPayerInvoices }) => (
  isNetworkLead || showPayerInvoices ? '/invoices/open' : '/invoices/draft'
);

export default getInvoicesPath;
